// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"3a8b184e","153":"94c234a9","216":"1908826d","692":"2465cb80","4972":"4d3e608a","5710":"94c234a9","7740":"cb37299c","9129":"2465cb80","9180":"aae1533f"}[chunkId] + ".chunk.css";
};